import React, { useContext, useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import {
  A0dashboard,
  CZHome,
  K1Information,
  J2Product,
  J2Settings,
  A4Electricalinstaller,
  J2Documentcopy,
  C1Roofwindowclose,
  E4Crowd,
  J2Detailcheck,
  J2Catalogue,
  B3Photovoltaic,
  H1Mail,
  I1Electriccar,
  K1Modularity,
  HZmusic,
  F1Couching,
  E1FinalLevel,
  E3CreateMacro,
  J2Key,
  H1Monologue,
  J2Setup,
  J2Launchapp,
  I1ElectricalChargingStation,
  CZBuildingAutomation,
  E3AI360,
  K1Gift,
  // K1Negociation,
} from '@e3dc-react/icons'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import { useTypedSelector } from 'src/State/RootReducer'
import { getEMobilityTabRoute } from 'src/Routes/P3_eMobility/routes'
import { getEMobilityTabRouteV1 } from 'src/Routes/P3_eMobility/routes-v1'
import { routes as solarModuleSettingsRoutes } from 'src/Libs/solar'
import { routes as batterySettingsRoutes } from 'src/Libs/batteries'
import { routes as powerMeterSettingsRoutes } from 'src/Libs/power-meters'
import { routes as wallboxSettingsRoutes } from 'src/Libs/wallboxes'
import { routes as emergencyPowerSettingsRoutes } from 'src/Libs/emergency-power'
import { getUserType } from 'src/Libs/user/functions/user-data'
import { UserLevel } from 'src/State/User/UserModel'
import { UserTypes } from 'src/Libs/user/types'
import { useUser } from 'src/Hooks/useUser'
import { useEffectShopAccess, useShop, useShopAdmin } from 'src/Libs/shop/hooks'
import { ShopHomePageResponse } from '../../Libs/shop/models/home-page-card.model'
import { CategoryType, SystemConfigureType } from 'src/Libs/shop/types'
import { VAD_CUSTOMER_GROUP_ID } from 'src/Libs/shop/consts'
import { useUserRoles } from 'src/Hooks/user'
import useInstallationsContext from 'src/Libs/installations/hooks/use-installations-context'
import { hasAccessToDirectMarketing, hasAccessToLuoxDirectMarketing } from 'src/Libs/installation-extensions/utils'
import { InstallationOnlineStatusContext } from 'src/Libs/installations/context/installation-online-status-context'
import { useLocation, Link as RouterLink } from 'react-router-dom'
import { InstallationOverviewPage } from 'src/Libs/navigation/types'
import { Category, CategoryItem, CategoryItemType } from '../Sidebar/Categories'
import {
  useHasNewFeature,
  FeatureElements,
  getHasElementNewContent,
  getHaveElementsNewContent,
  FeatureContentVersionType,
  useDynamicSystemSettingsElementKeys,
} from 'src/Libs/new-content'
import useActiveInstallationContext from 'src/Libs/installations/hooks/use-active-installation-context'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { useActiveInstallation, useIsWebviewMode } from 'src/Hooks'
import {
  EMobilityImplementation,
  EMobilityImplementationCheckStatus,
  useSelectEMobilityImplementation,
} from 'src/Libs/e-mobility/use-select-e-mobility-implementation'
import { useShouldEnableEMobilitySection } from 'src/Libs/e-mobility/shared/hooks/use-should-enable-e-mobility-section'
import { useExtensionAccess } from 'src/Libs/installation-extensions'
import { TibberSoftwareSupport } from 'src/Libs/installation-extensions/config'
import { useAppRatingContext } from 'src/Libs/app-rating/hooks'
import { Link } from '@mui/material'
import { isUndefined } from 'lodash'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'
import { getAdvancedSettingsDetailsRoute, getPropertiesSettingsDetailsRoute } from 'src/Libs/flow/advanced-settings/routes'
import { getSystemStatusUrl } from 'src/Libs/system-status'
import { getEndUserSettingsRoutes } from 'src/Libs/flow/end-user-settings/general/utils/routes'
import { INSTALLER_PARTNER, SERVICE_LEVELS } from 'src/Configuration'
import { useSmarthomeModuleState } from 'src/Libs/smart-home/hooks'
import { useIsDynamicEmsAccessible } from 'src/Libs/dynamic-power-prices'
import { getRightsManagementRoute } from 'src/Libs/installation-rights-management'
import { useFarmContext } from '../Farm'
import { useInstallationAccessType } from 'src/Libs/installations/hooks/use-installation-access-type'
import { createDashboardIdsWithSuffix, getInstallationDashboardUrlByIds } from 'src/Libs/dashboard/routes'
import { getStorageBatteriesSettingsRoute } from 'src/Libs/flow/battery-settings'

const REONIC_URL = 'https://portal.reonic.de/login'

const getNavItemsForOverview = (
  currentFeatureContentVersion: FeatureContentVersionType,
  userLevel?: UserLevel,
  isManager = false
): CategoryItem[] => {
  const companyManagementNavItem = {
    translationKey: 'framework.company',
    dataQa: 'framework-company',
    icon: <E4Crowd />,
    href: '/company/permissions',
    hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.OverviewSideBarElement),
    elementKeys: [FeatureElements.OverviewSideBarElement],
  }

  const userItems: CategoryItem[] = [
    {
      translationKey: 'framework.overview',
      dataQa: 'framework-overview',
      icon: <A0dashboard />,
      href: InstallationOverviewPage.Overview,
      hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.OverviewSideBarElement),
      elementKeys: [FeatureElements.OverviewSideBarElement],
    },
  ]
  const installerItems: CategoryItem[] = (
    [
      {
        translationKey: 'framework.overview',
        dataQa: 'framework-overview',
        icon: <A0dashboard />,
        href: InstallationOverviewPage.InstallerDashboard,
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.OverviewSideBarElement),
        elementKeys: [FeatureElements.OverviewSideBarElement],
      },
      isManager && companyManagementNavItem,
    ] as CategoryItem[]
  ).filter(Boolean)
  const partnerItems: CategoryItem[] = [...installerItems]
  const serviceItems: CategoryItem[] = [
    {
      translationKey: 'framework.administration.administration',
      icon: <A0dashboard />,
      href: '/overview',
      dataQa: 'framework-administration',
      hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.OverviewSideBarElement),
      elementKeys: [FeatureElements.OverviewSideBarElement],
    },
  ]
  const defaultItems: CategoryItem[] = [
    {
      translationKey: 'framework.overview',
      icon: <J2Product />,
      href: '/overview',
      dataQa: 'framework-overview',
      hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.OverviewSideBarElement),
      elementKeys: [FeatureElements.OverviewSideBarElement],
    },
  ]

  const navItemMap = new Map<UserLevel, CategoryItem[]>(
    [
      ['USER', userItems],
      ['INSTALLER', installerItems],
      ['PARTNER', partnerItems],
      ['E3DC_SERVICE', serviceItems],
      isFlowTheme ? ['EXT_SERVICE_PLUS', serviceItems] : undefined,
      ['E3DC_ADMIN', serviceItems],
      ['E3DC_ROOT', serviceItems],
    ].filter(Boolean) as [UserLevel, CategoryItem[]][]
  )

  if (userLevel) return [...(navItemMap.get(userLevel) ?? defaultItems)]

  return defaultItems
}

const useLinks = (): Category[] => {
  const { t } = useCustomTranslation()
  const {
    featureFlags: {
      isCustomerReferralEnabled,
      isTibberEnabled,
      isAppRatingEnabled,
      isReonicEnabled,
      isShopMaintenanceModeEnabled,
      isCreateInstallationEnabled,
      isProductFilesEnabled,
      batterySettingsEnabled,
      isExtensionsPageVisibleInFlow,
    },
    isFeatureFlagsLoading,
  } = useFeatureFlagsContext()
  const { getShopLinks } = useShop()
  const { checkIsShopUserAdmin } = useShopAdmin()
  const [shopLinks, setShopLinks] = useState<ShopHomePageResponse[]>([])
  const {
    installationId: activeInstallation,
    storageId: activeStorage,
    storageDeviceLink,
    installation,
    installationError,
    deviceLinksLoading,
  } = useActiveInstallationContext()
  const installationAccessType = useInstallationAccessType(installation)

  const currentInstallation = useTypedSelector(state => state.storage.installation)
  const links: Category[] = []
  const userLevel = useTypedSelector(state => state.user.userData?.level)
  const { userData, userCompany } = useUser()
  const { installationCount } = useInstallationsContext()
  const shopAccess = useTypedSelector(state => state.shop.shopAccess)
  const customerGroupId = useTypedSelector(state => state.shop.customerGroupId)
  const hasUserCompanyShopAccess = useTypedSelector(state => state.user.company?.shopPermission)
  const selectedUserCustomerGroupId = useTypedSelector(state => state.shop.selectedUserData?.customerGroupId)
  const { isFarm, isFarmMasterSelected } = useFarmContext()
  const storageSubheading = activeStorage
  const isFarmClientSelected = isFarm && !isFarmMasterSelected
  const { currentFeatureContentVersion } = useHasNewFeature()
  const { smartFunctionsElementKeys, systemSettingsElementKeys } = useDynamicSystemSettingsElementKeys()
  const { userCanRead } = useActiveInstallation(true, activeInstallation?.toString() ?? '', activeStorage ?? '')
  const { hasAccess: hasTibberAccess } = useExtensionAccess(isTibberEnabled, TibberSoftwareSupport.Year, TibberSoftwareSupport.MonthPatch)
  const hasLuoxDirectMarketingAccess = hasAccessToLuoxDirectMarketing(currentInstallation, userData)
  const isSmarthomeAvailable = useSmarthomeModuleState(activeInstallation?.toString())
  const { isDynamicEmsV2Accessible } = useIsDynamicEmsAccessible()
  const isPlannedInstallation =
    installationAccessType === 'e3dc-setup-configurator-access' || installationAccessType === 'e3dc-setup-restricted-access'

  /* TODO: refactor this in a proper "isManager" behaviour */
  const isManager =
    userLevel &&
    (['INSTALLER', 'PARTNER', 'EXT_SERVICE', 'E3DC_SERVICE', 'EXT_SERVICE_PLUS'] as UserLevel[]).includes(userLevel) &&
    userCompany?.Manager === userData?.ID
  const { openAppRating } = useAppRatingContext()
  const { isUser, isServiceUser } = useUserRoles()
  const location = useLocation()
  const shop = useTypedSelector(state => state.shop)
  const selectedUserShopToken = shop.selectedUserData?.contextToken
  const isShopAdmin = checkIsShopUserAdmin()
  const managerHasShopAccess = isShopAdmin && shop.selectedUserData !== null
  const allowShopCategories = !isShopAdmin || managerHasShopAccess
  const isVadCustomerGroup = customerGroupId === VAD_CUSTOMER_GROUP_ID
  const selectedUserIsVadCustomerGroup = selectedUserCustomerGroupId === VAD_CUSTOMER_GROUP_ID
  const hasPromotionCodeAccess = isVadCustomerGroup || selectedUserIsVadCustomerGroup

  const dashboardDisabled = ((isUser && installationCount > 1) || !isUser) && installationAccessType === 'access-denied'
  const installationLinksDisabled = installationAccessType !== 'full-access'
  const propertiesAdvancedSettingsDisabled = installationAccessType !== 'full-access' && installationAccessType !== 'flow-setup-configurator-access'
  const rightsManagementDisabled =
    installationAccessType !== 'full-access' &&
    installationAccessType !== 'flow-setup-configurator-access' &&
    installationAccessType !== 'flow-setup-restricted-access'
  const configuratorDisabled = installationAccessType !== 'e3dc-setup-configurator-access' || !isCreateInstallationEnabled
  /* With systems beeing able to be decomissioned we need to make sure to only enable the link if there is an active device link */
  /* While device links are still loading we keep the links enabled to avoid falsely disabling them during navigation. */
  const linksWithRequiredStorageDisabled = !activeStorage || (!deviceLinksLoading && (!storageDeviceLink || !!storageDeviceLink.decommissionedAt))

  const { isStorageOnline } = useContext(InstallationOnlineStatusContext)
  const {
    eMobilityImplementation,
    isLoading: isEMobilityImplementationLoading,
    status: eMobilityImplementationCheckStatus,
  } = useSelectEMobilityImplementation({ installationId: activeInstallation, skipCheck: linksWithRequiredStorageDisabled })
  const { shouldEnableEMobilityLink } = useShouldEnableEMobilitySection()
  const isWebView = useIsWebviewMode()

  const overview = (): Category[] => {
    const items = getNavItemsForOverview(currentFeatureContentVersion, userLevel, isManager).map(item => ({
      ...item,
      translationKey: t(item.translationKey),
    }))
    return [
      {
        name: '',
        items: [...items],
      },
    ]
  }

  useEffectShopAccess(() => {
    getShopLinks()
      .then(result => setShopLinks(result))
      .catch(error => console.error(error))
  }, [selectedUserShopToken]) //eslint-disable-line react-hooks/exhaustive-deps

  const ownerName =
    currentInstallation?.ownerFirstName && currentInstallation?.ownerLastName
      ? `${currentInstallation.ownerFirstName} ${currentInstallation.ownerLastName}`
      : undefined

  const installationLink =
    isServiceUser && !isPlannedInstallation ? (
      <Link component={RouterLink} to={`/overview/installations/${activeInstallation}`} sx={{ textDecoration: 'none' }}>
        {activeInstallation}
      </Link>
    ) : (
      activeInstallation?.toString()
    )

  const serialNumberLink =
    isServiceUser && !isFlowTheme && !isPlannedInstallation ? (
      <Link component={RouterLink} to={`/overview/installations/${activeInstallation}/${storageSubheading}/details`} sx={{ textDecoration: 'none' }}>
        {storageSubheading}
      </Link>
    ) : (
      storageSubheading?.toString()
    )

  const ownerLink =
    isServiceUser && !isFlowTheme && ownerName && currentInstallation?.ownerId ? (
      <Link component={RouterLink} to={`/overview/users/${currentInstallation.ownerAccountId}`} sx={{ textDecoration: 'none' }}>
        {ownerName}
      </Link>
    ) : (
      ownerName
    )

  const installationInfo = (): Category => {
    return {
      name: !isUndefined(activeInstallation) ? (
        <>
          {t('framework.installation.installation')} <>- {installationLink}</>
        </>
      ) : undefined,
      nameCollapsed: activeInstallation ? installationLink : '',
      subheader: storageSubheading ? (
        <>
          {t('framework.installation.serialnumberShort', { serialnumber: '' })}
          {serialNumberLink}
        </>
      ) : undefined,
      subheaderCollapsed: storageSubheading ? serialNumberLink : '',
      tertiaryheader: ownerName && (
        <>
          {t('framework.installation.owner')} <>- {ownerLink} </>
        </>
      ),
      items: [],
    }
  }

  const getThemedSystemSettingsSubLinks = (): CategoryItem[] => {
    const isServiceInstallerUser = userLevel ? [...INSTALLER_PARTNER, ...SERVICE_LEVELS].includes(userLevel) : false

    const tariffSettingsRouteConfig = {
      translationKey: t('framework.tariffs.title'),
      href: `/installation/${activeInstallation}/${activeStorage}/properties/tariffs`,
      disabled: installationLinksDisabled || !isStorageOnline,
      dataQa: 'framework-tariffs',
      hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyTariffsSideBarElement),
      elementKeys: [FeatureElements.PropertyTariffsSideBarElement],
    }

    if (isFlowTheme) {
      const subLinks = []

      subLinks.push(
        {
          translationKey: t('framework.grid-and-system-protection-configuration'),
          href: `/installation/${activeInstallation}/${activeStorage}/properties/grid-and-system-protection-configuration`,
          disabled: installationLinksDisabled || !isStorageOnline,
          dataQa: 'framework-grid-and-system-protection-configuration',
          hasNewContent: getHasElementNewContent(
            currentFeatureContentVersion,
            FeatureElements.PropertyGridAndSystemProtectionConfigurationSideBarElement
          ),
          elementKeys: [FeatureElements.PropertyGridAndSystemProtectionConfigurationSideBarElement],
          hide: !isServiceInstallerUser,
        },
        {
          translationKey: t('framework.battery'),
          href: getStorageBatteriesSettingsRoute(activeInstallation?.toString(), activeStorage),
          disabled: installationLinksDisabled,
          dataQa: 'framework-storage',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyStorageBatterySettingsElement),
          elementKeys: [FeatureElements.PropertyStorageBatterySettingsElement],
          hide: !isServiceInstallerUser || isFeatureFlagsLoading || !batterySettingsEnabled,
        },
        {
          translationKey: t('framework.advanced-settings'),
          href: `${getAdvancedSettingsDetailsRoute(activeInstallation?.toString(), activeStorage)}`,
          disabled: propertiesAdvancedSettingsDisabled,
          dataQa: 'framework-advanced-settings',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyAdvancedSettingsSideBarElement),
          elementKeys: [FeatureElements.PropertyAdvancedSettingsSideBarElement],
        },
        tariffSettingsRouteConfig,
        {
          translationKey: t('framework.end-user.solar'),
          href: getEndUserSettingsRoutes('solarPriority', activeInstallation?.toString(), activeStorage),
          disabled: installationLinksDisabled,
          dataQa: 'framework-end-user-solar',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyEndUserSettingsSolarElement),
          elementKeys: [FeatureElements.PropertyEndUserSettingsSolarElement],
        },
        {
          translationKey: t('framework.end-user.badges'),
          href: getEndUserSettingsRoutes('badges', activeInstallation?.toString(), activeStorage),
          disabled: installationLinksDisabled,
          dataQa: 'framework-end-user-badges',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyEndUserSettingsBadgesElement),
          elementKeys: [FeatureElements.PropertyEndUserSettingsBadgesElement],
        },
        {
          translationKey: t('framework.end-user.wallbox'),
          href: getEndUserSettingsRoutes('wallbox', activeInstallation?.toString(), activeStorage),
          disabled: installationLinksDisabled,
          dataQa: 'framework-end-user-wallbox',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyEndUserSettingsWallboxElement),
          elementKeys: [FeatureElements.PropertyEndUserSettingsWallboxElement],
        },
        {
          translationKey: t('framework.end-user.storage'),
          href: getEndUserSettingsRoutes('storage', activeInstallation?.toString(), activeStorage),
          disabled: installationLinksDisabled,
          dataQa: 'framework-end-user-storage',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyEndUserSettingsStorageEnergyManagementElement),
          elementKeys: [FeatureElements.PropertyEndUserSettingsStorageEnergyManagementElement],
        },
        {
          translationKey: t('framework.end-user.boiler'),
          href: getEndUserSettingsRoutes('boiler', activeInstallation?.toString(), activeStorage),
          disabled: installationLinksDisabled,
          dataQa: 'framework-end-user-boiler',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyEndUserSettingsBoilerElement),
          elementKeys: [FeatureElements.PropertyEndUserSettingsBoilerElement],
        }
      )

      return subLinks
    }
    return [
      //for dropdown inside menu, we keep the other items prop in case we need it in the future.
      {
        translationKey: t('framework.solar'),
        href: `${solarModuleSettingsRoutes.getBaseRoute(activeInstallation, activeStorage)}`,
        disabled: installationLinksDisabled || !isStorageOnline,
        dataQa: 'framework-solar',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertySolarSideBarElement),
        elementKeys: [FeatureElements.PropertySolarSideBarElement],
      },
      {
        translationKey: t('framework.battery'),
        href: `${batterySettingsRoutes.getBatteriesDispatchRoute(activeInstallation, activeStorage)}`,
        disabled: installationLinksDisabled || !isStorageOnline,
        dataQa: 'framework-battery',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyBatterySideBarElement),
        elementKeys: [FeatureElements.PropertyBatterySideBarElement],
      },
      {
        translationKey: t('framework.powermeter'),
        href: `${powerMeterSettingsRoutes.getDetailsDispatchRoute(activeInstallation, activeStorage)}`,
        disabled: installationLinksDisabled || !isStorageOnline,
        dataQa: 'framework-powermeter',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyPowermeterSideBarElement),
        elementKeys: [FeatureElements.PropertyPowermeterSideBarElement],
      },
      {
        translationKey: t('framework.wallbox'),
        href: `${wallboxSettingsRoutes.getBaseRoute(activeInstallation, activeStorage)}`,
        disabled: installationLinksDisabled || !isStorageOnline,
        dataQa: 'framework-wallbox',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyWallboxSideBarElement),
        elementKeys: [FeatureElements.PropertyWallboxSideBarElement],
      },
      /* TODO: revert changes made in CPE-1861 */

      {
        translationKey: t('framework.smartFunctions.title'),
        href: `/installation/${activeInstallation}/${activeStorage}/properties/smart-functions`,
        disabled: installationLinksDisabled || !isStorageOnline,
        dataQa: 'framework-smart-functions',
        hasNewContent: getHaveElementsNewContent(currentFeatureContentVersion, smartFunctionsElementKeys),
        elementKeys: smartFunctionsElementKeys,
      },

      tariffSettingsRouteConfig,

      {
        translationKey: t('framework.emergency-power'),
        href: `${emergencyPowerSettingsRoutes.getDetailsRoute(activeInstallation, activeStorage)}`,
        disabled: installationLinksDisabled || !isStorageOnline,
        dataQa: 'framework-emergency-power',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyEmergencyPowerSideBarElement),
        elementKeys: [FeatureElements.PropertyEmergencyPowerSideBarElement],
      },
      {
        translationKey: t('framework.installation.installation'),
        href: `/installation/${activeInstallation}/${activeStorage}/properties/installation`,
        disabled: installationLinksDisabled || !isStorageOnline,
        dataQa: 'framework-installation',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.PropertyInstallationSideBarElement),
        elementKeys: [FeatureElements.PropertyInstallationSideBarElement],
      },
    ]
  }

  const installationLinks = (): Category => {
    const links: Category = {
      name: <>{t('framework.installation.installation')}</>,
      nameCollapsed: <>{t('framework.installation.installation')}</>,
      items: [
        ...(configuratorDisabled
          ? []
          : [
              {
                translationKey: t('framework.installation-configuration'),
                icon: <J2Setup />,
                // Click should always land on the default tab
                href: `/installation/${activeInstallation}/configuration/general`,
                // ...but active state should match the whole configuration section
                activeHref: `/installation/${activeInstallation}/configuration`,
                dataQa: 'framework-installation-configuration',
                disabled: false,
                hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.InstallationConfigurationSideBarElement),
                elementKeys: [FeatureElements.InstallationConfigurationSideBarElement],
              },
            ]),
        {
          translationKey: t('framework.dashboard'),
          icon: <CZHome />,
          href: getInstallationDashboardUrlByIds(activeInstallation, activeStorage),
          disabled: dashboardDisabled,
          dataQa: 'framework-dashboard',
          hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.DashboardSideBarElement),
          elementKeys: [FeatureElements.DashboardSideBarElement],
          exact: true,
        },
        {
          translationKey: t('framework.systemProperties'),
          icon: <J2Settings />,
          href: getPropertiesSettingsDetailsRoute(activeInstallation?.toString(), activeStorage),
          disabled: propertiesAdvancedSettingsDisabled,
          dataQa: 'framework-system-properties',
          hasNewContent: getHaveElementsNewContent(currentFeatureContentVersion, systemSettingsElementKeys),
          elementKeys: systemSettingsElementKeys,
          selectItems: getThemedSystemSettingsSubLinks(),
        },
        {
          translationKey: t('framework.vehicle-integration'),
          icon: <I1Electriccar />,
          href: `/vehicle-integration/${activeInstallation}/${activeStorage}/vehicle-integration`,
          activeHref: `/vehicle-integration/${activeInstallation}`,
          dataQa: 'framework-vehicle-integration',
          disabled: installationLinksDisabled || installationError,
          elementKeys: [FeatureElements.VehicleIntegrationSideBarElement],
          hasNewContent: getHaveElementsNewContent(currentFeatureContentVersion, [FeatureElements.VehicleIntegrationSideBarElement]),
        },
        {
          translationKey: t('framework.eMobilityOverview'),
          icon: <I1ElectricalChargingStation />,
          href: (() => {
            /**
             * There are cases when we are unable to determine if new frontend can be shown(network request to HagerBridge fails) and with that,
             * which route should be shown initially(dashboard for new e-mobility or charging-sessions for old e-mobility).
             *
             * Also, we do not want to keep the user waiting longer than necessary for this information to be fetched, but
             * let them enter the e-mobility section("/e-mobility") and wait for the request completion there. Redirects are set up for each version
             * of the frontend so that upon completion, the user will be shown the correct tab.
             */
            if (isEMobilityImplementationLoading || eMobilityImplementationCheckStatus !== EMobilityImplementationCheckStatus.Success) {
              if (activeStorage) {
                return `/e-mobility/${activeInstallation}/${activeStorage}`
              }
              return `/e-mobility/${activeInstallation}`
            }

            /**
             * Even though the redirect from "/e-mobility" to "dashboard" or "charging-sessions" happens automatically, if we immediately specify the
             * correct initial tab, we will save one navigation action, one render cycle and prevent a slight flicker of the e-mobility page while
             * redirect is ongoing.
             */
            return eMobilityImplementation === EMobilityImplementation.V1
              ? getEMobilityTabRouteV1(activeInstallation, activeStorage, 'charging-sessions')
              : getEMobilityTabRoute(activeInstallation, activeStorage, 'dashboard')
          })(),
          activeHref: `/e-mobility/${activeInstallation}`, // activeHref is declared so that the sidebar link matches both variants of e-mobility route(with or without the storage id)
          dataQa: 'framework-e-mobility',
          disabled: !shouldEnableEMobilityLink,
          hasNewContent:
            eMobilityImplementation === EMobilityImplementation.V2 ||
            getHasElementNewContent(currentFeatureContentVersion, FeatureElements.EMobilitySideBarElement),
          elementKeys: [FeatureElements.EMobilitySideBarElement],
        },
        ...(isSmarthomeAvailable
          ? [
              {
                translationKey: t('framework.smart-home'),
                icon: <CZBuildingAutomation />,
                href: `smart-home/${activeInstallation}/${activeStorage}`,
                dataQa: 'framework-smartHome',
                hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.SmartHomeSidebarElement),
                elementKeys: [FeatureElements.SmartHomeSidebarElement],
              },
            ]
          : []),
        ...(isDynamicEmsV2Accessible && !isFlowTheme
          ? [
              {
                translationKey: t('dashboard.ai360.title'),
                icon: <E3AI360 />,
                href: `/dashboard/ai360/${activeInstallation}/${activeStorage}`,
                disabled: linksWithRequiredStorageDisabled,
                dataQa: 'dashboard-ai360-title',
                exact: true,
                hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.AI360SidebarElement),
                elementKeys: [FeatureElements.AI360SidebarElement],
              },
            ]
          : []),
        {
          translationKey: t('framework.systemStatus.title'),
          icon: <J2Detailcheck />,
          href: getSystemStatusUrl(activeInstallation, activeStorage),
          disabled: linksWithRequiredStorageDisabled,
          dataQa: 'dashboard-systemStatus-title',
          exact: false,
        },
        {
          translationKey: t('dashboard.documents.title'),
          icon: <J2Catalogue />,
          href: `/dashboard/documents/${activeInstallation}/${activeStorage}`,
          disabled: linksWithRequiredStorageDisabled,
          dataQa: 'dashboard-documents-title',
          exact: true,
        },
        {
          translationKey: t('dashboard.rightsAdministration.title'),
          icon: <J2Key />,
          href: getRightsManagementRoute(activeInstallation?.toString(), activeStorage),
          disabled: rightsManagementDisabled || isFarmClientSelected,
          dataQa: 'dashboard-rightsAdministration-title',
          exact: true,
          hide: !userCanRead,
        },
      ],
    }

    const isRefreshOnInstallationExtensionPage = location.pathname.includes('installation-extension')

    if (
      (installationCount > 0 && (!isFlowTheme || isExtensionsPageVisibleInFlow) && hasAccessToDirectMarketing(currentInstallation, userData)) ||
      isRefreshOnInstallationExtensionPage
    ) {
      const elementsToCheck = [FeatureElements.ExtensionSideBarElement]

      if (!isFlowTheme && hasTibberAccess) elementsToCheck.push(FeatureElements.TibberExtensionElement)
      if (!isFlowTheme && hasLuoxDirectMarketingAccess) elementsToCheck.push(FeatureElements.LuoxDynamicTariffExtensionElement)

      const hasNewContent = elementsToCheck.some(element => getHasElementNewContent(currentFeatureContentVersion, element))

      links.items.push({
        translationKey: t('framework.installation-extensions'),
        icon: <K1Modularity />,
        href: `/installation-extensions/${activeInstallation}/${activeStorage}`,
        dataQa: 'framework-installation-extensions',
        disabled: installationLinksDisabled,
        hasNewContent: hasNewContent,
        elementKeys: elementsToCheck,
      })
    }

    /* TODO: revert changes made in CPE-1897 */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const serviceItems: CategoryItem[] = [
      {
        translationKey: t('framework.system-properties'),
        icon: <J2Detailcheck />,
        href: createDashboardIdsWithSuffix('/dashboard/system-property', activeInstallation, activeStorage),
        disabled: true,
        dataQa: 'framework-system-settings',
      },
      {
        translationKey: t('framework.rc-logs'),
        icon: <J2Catalogue />,
        href: createDashboardIdsWithSuffix('/dashboard/rc-logs', activeInstallation, activeStorage),
        disabled: true,
        dataQa: 'framework-rc-logs',
      },
    ]

    if (userLevel === 'E3DC_SERVICE') {
      const serviceLinks: Category = { ...links }
      /* TODO: revert changes made in CPE-1897 */
      // serviceLinks.items.push(...serviceItems)
      return serviceLinks
    }
    return isFlowTheme
      ? {
          ...links,
          items: links.items.filter(
            item =>
              item.dataQa === 'framework-dashboard' ||
              item.dataQa === 'framework-system-properties' ||
              item.dataQa === 'framework-e-mobility' ||
              item.dataQa === 'framework-installation-extensions' ||
              item.dataQa === 'dashboard-systemStatus-title' ||
              item.dataQa === 'dashboard-rightsAdministration-title'
          ),
        }
      : links
  }

  /*
   * This function detects the type of category and redirect user to the current navigation category.
   * Since we get all the categories from backend. we have to detect if its System Configure / Favorite System or Normal Category.
   */
  const generateShopHrefType = (navigate: ShopHomePageResponse): string => {
    if (navigate.type === CategoryType.QntmSystemConfiguratioName) {
      return `/shop/system-configure/${SystemConfigureType.QntmSystem}`
    }

    if (navigate.type === CategoryType.SystemConfigurationName) {
      return `/shop/system-configure/${SystemConfigureType.NormalSystem}`
    }

    if (navigate.type === CategoryType.FavoriteSystemConfigurationName) {
      return '/shop/favorite-system'
    }

    return `/shop/category/${navigate.id}/${navigate.translated.name}`
  }

  /* TODO: add project administration item to the business part when needed (changes made in CPE-1861) */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const projectAdministrationItem = {
    translationKey: t('framework.projectAdministration'),
    icon: <J2Documentcopy />,
    href: '/business/projectAdministration',
    dataQa: 'framework-project-administration',
    disabled: true,
  }

  /* TODO: add inverter layout item to the business part when needed (changes made in CPE-1861) */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const inverterLayoutItem = {
    translationKey: t('framework.inverterLayout'),
    icon: <C1Roofwindowclose />,
    href: '/business/inverterLayout',
    dataQa: 'framework-inverter-direction',
    disabled: true,
  }

  /* TODO: revert change made in CPE-1897 when needed */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const solarModulesItem = {
    translationKey: t('framework.solarModules'),
    icon: <B3Photovoltaic />,
    href: '/administration/solar-modules',
    dataQa: 'framework-solar-modules',
  }

  /* TODO: revert change made in CPE-1897 when needed */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const batteryDataExportItem = {
    translationKey: t('framework.battery-data-export'),
    icon: <J2Documentcopy />,
    href: '/administration/battery-data-export',
    dataQa: 'framework-battery-data-export',
  }

  /* TODO: revert change made in CPE-1897 when needed */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const documentsItem = {
    translationKey: t('framework.documents'),
    icon: <J2Documentcopy />,
    href: '/administration/documents',
    dataQa: 'framework-documents',
  }

  /* TODO: revert change made in CPE-1897 when needed */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const notificationItem = {
    translationKey: t('framework.notifications'),
    icon: <H1Mail />,
    href: '/administration/notifications',
    dataQa: 'framework-notifications',
    disabled: true,
  }

  const generateShopLinks = (shopLinks: ShopHomePageResponse[]): CategoryItem[] => {
    return shopLinks.map(navigate => ({
      translationKey: navigate.translated.name,
      href: generateShopHrefType(navigate),
      disabled: false,
      dataQa: navigate.translated.name,
    }))
  }

  const generateShopItemsAndLinks = (shopLinks: ShopHomePageResponse[]): CategoryItem[] => {
    const isAdminAllowedToAccesShop = isShopAdmin && shopAccess
    const shopItems: CategoryItem[] =
      /* This is bigger than 1 since Shop Return the System Configure category even when other categories might not be on Shop */
      isAdminAllowedToAccesShop || shopLinks.length > 1
        ? [
            {
              translationKey: t('framework.homepage'),
              href: '/shop/homepage',
              disabled: false,
              dataQa: 'framework-homepage',
              hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.ExtensionSideBarElement),
              elementKeys: [FeatureElements.ExtensionSideBarElement],
            },
            ...generateShopLinks(shopLinks),
            {
              translationKey: t('framework.orderHistory'),
              href: '/shop/order-history',
              disabled: false,
              dataQa: 'framework-homepage',
            },
            ...(hasPromotionCodeAccess
              ? [
                  {
                    translationKey: t('framework.promotion-codes'),
                    href: '/shop/promotion-codes',
                    disabled: false,
                    dataQa: 'framework-promotion-codes',
                  },
                ]
              : []),
          ]
        : []

    const hasShopItems = shopItems.length > 0
    const showShop = isShopAdmin ? hasShopItems : hasUserCompanyShopAccess
    const isShopNormalyDisabled = isShopAdmin ? !hasShopItems : !shopAccess || !hasShopItems
    const isShopDisabled = showShop && isShopMaintenanceModeEnabled ? false : isShopNormalyDisabled

    const items: CategoryItem[] = [
      ...(showShop
        ? [
            {
              translationKey: t(isShopAdmin ? 'framework.shopAdministration' : 'framework.shop'),
              icon: <ShoppingCartOutlinedIcon />,
              disabled: isShopDisabled,
              href: '/shop/homepage',
              dataQa: 'framework-shop',
              hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.ShopSideBarElement),
              elementKeys: [FeatureElements.ShopSideBarElement],
              ...(allowShopCategories ? { selectItems: shopItems } : {}),
            },
          ]
        : []),
    ]

    return items
  }

  const business = (): Category[] => {
    const items: CategoryItem[] = generateShopItemsAndLinks(shopLinks)

    if (isReonicEnabled) {
      items.push({
        translationKey: t('framework.reonic-configurator'),
        icon: <J2Setup />,
        rightIcon: <J2Launchapp />,
        href: REONIC_URL,
        dataQa: 'framework-reonic-configurator',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.ReonicConfiguratorSidebarElement),
        elementKeys: [FeatureElements.ReonicConfiguratorSidebarElement],
      })
    }
    if (items.length === 0) return []

    return [
      {
        name: t('framework.business'),
        items,
      },
    ]
  }

  const service = (): Category => {
    const items: CategoryItem[] = []
    items.push({
      translationKey: t('framework.documents'),
      icon: <J2Documentcopy />,
      href: '/downloads',
      dataQa: 'framework-documents',
      hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.DocumentsSidebarElement),
      elementKeys: [FeatureElements.DocumentsSidebarElement],
    })

    if (isServiceUser && isProductFilesEnabled) {
      items.push({
        translationKey: t('framework.product-files'),
        icon: <J2Catalogue />,
        href: '/product-files',
        dataQa: 'framework-product-files',
      })
    }

    items.push({
      translationKey: t('framework.retrofit-check'),
      icon: <E3CreateMacro />,
      href: `/retrofit-check/${activeInstallation}/${activeStorage}`,
      dataQa: 'framework-retrofit-check',
      hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.RetrofitSidebarElement),
      elementKeys: [FeatureElements.RetrofitSidebarElement],
      disabled: linksWithRequiredStorageDisabled,
    })

    items.push({
      translationKey: t('framework.contact'),
      icon: <HZmusic />,
      href: '/contact',
      dataQa: 'framework-contact',
      hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.ContactSideBarElement),
      elementKeys: [FeatureElements.ContactSideBarElement],
    })
    const inverterToolLinkData = {
      translationKey: t('framework.inverter-tool'),
      icon: <E1FinalLevel />,
      href: '/inverter-tool',
      dataQa: 'framework-inverter-tool',
    }

    if (userType === UserTypes.service) {
      items.push(
        {
          translationKey: t('framework.referal-codes'),
          icon: <K1Gift />,
          href: '/referal-codes',
          dataQa: 'referal-codes',
        },
        inverterToolLinkData
      )
    }

    if (userType === UserTypes.installerPartner) {
      items.push(inverterToolLinkData)
    }

    if (isFlowTheme) {
      items.push({
        translationKey: t('framework.document-links'),
        icon: <J2Catalogue />,
        href: '/document-links',
        dataQa: 'framework-document-links',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.DocumentLinksSidebarElement),
        elementKeys: [FeatureElements.DocumentLinksSidebarElement],
      })
    }

    const links: Category = {
      name: t('framework.service'),
      items: items.filter(link => {
        if (!isFlowTheme) return true
        return link.dataQa === 'framework-contact' || link.dataQa === 'framework-document-links'
      }),
    }

    if (isCustomerReferralEnabled) {
      links.items.push({
        translationKey: t('framework.referral'),
        icon: <F1Couching />,
        href: '/referral',
        dataQa: 'framework-referral',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.ReferFriendsSideBarElement),
        elementKeys: [FeatureElements.ReferFriendsSideBarElement],
      })
    }

    if (isWebView && isAppRatingEnabled) {
      links.items.push({
        translationKey: t('framework.rate-app'),
        icon: <H1Monologue />,
        dataQa: 'framework-rate-app',
        onClick: () => openAppRating(),
        type: CategoryItemType.BUTTON,
      })
    }

    return links
  }

  const management = (): Category => {
    return {
      name: t('framework.service'),
      items: isFlowTheme
        ? []
        : [
            ...generateShopItemsAndLinks(shopLinks),
            {
              icon: <H1Mail />,
              translationKey: t('framework.message-of-the-day'),
              href: '/message-of-the-day',
              dataQa: 'framework-message-of-the-day',
              hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.MessageOfTheDaySideBarElement),
              elementKeys: [FeatureElements.MessageOfTheDaySideBarElement],
            },
          ],
    }
  }

  const serviceAndManagment = (): Category => ({
    name: t('framework.service'),
    items: [...service().items, ...management().items],
  })

  /*
   * TODO: Answer the question what links are still required here for the admin user?
   */
  const administration: Category[] = [
    {
      name: t('framework.administration.userManagement'),
      items: [
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.installations'),
          href: '/administration/installations',
          dataQa: 'framework-admin-installations',
        },
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.companies'),
          href: '/administration/companies',
          dataQa: 'framework-admin-companies',
        },
        { icon: <J2Product />, translationKey: t('framework.administration.users'), href: '/administration/users', dataQa: 'framework-admin-users' },
      ],
    },
    {
      name: t('framework.administration.management'),
      items: [
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.solarModules'),
          href: '/administration/solar-modules',
          dataQa: 'framework-admin-solarModules',
        },
        { icon: <J2Product />, translationKey: t('framework.administration.ibn'), href: '/administration/ibn', dataQa: 'framework-admin-ibn' },
        { icon: <J2Product />, translationKey: t('framework.administration.nda'), href: '/administration/nda', dataQa: 'framework-admin-nda' },
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.documents'),
          href: '/administration/documents',
          dataQa: 'framework-admin-documents',
        },
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.messageOfTheDay'),
          href: '/administration/message-of-the-day',
          dataQa: 'framework-admin-messageOfTheDay',
        },
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.batteryDataExport'),
          href: '/administration/battery-data-export',
          dataQa: 'framework-admin-export',
        },
      ],
    },
    {
      name: t('framework.administration.installer'),
      items: [
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.examManagement'),
          href: '/administration/exams',
          dataQa: 'framework-admin-exams',
        },
        {
          icon: <J2Product />,
          translationKey: t('framework.administration.ipinAwardList'),
          href: '/administration/ipin-award-list',
          dataQa: 'framework-admin-ipinList',
        },
      ],
    },
  ]

  const adminLinks: Category = {
    name: 'adminLinks',
    items: [
      {
        translationKey: t('framework.ibn'),
        icon: <K1Information />,
        href: '/commissioning-declaration',
        dataQa: 'framework-admin-commissioning-declaration',
      },
      {
        translationKey: t('framework.installerDashboard'),
        icon: <A4Electricalinstaller />,
        href: 'installer-dashboard',
        dataQa: 'framework-admin-installer-dashboard',
        hasNewContent: getHasElementNewContent(currentFeatureContentVersion, FeatureElements.OverviewSideBarElement),
        elementKeys: [FeatureElements.OverviewSideBarElement],
      },
    ],
  }

  const userType = userLevel ? getUserType(userLevel, installationCount) : undefined

  if (userType === UserTypes.owner) {
    links.push(installationInfo(), installationLinks(), service())
  } else if (userType === UserTypes.installationOverview) {
    links.push(...overview(), installationInfo(), installationLinks(), service())
  } else if (userType === UserTypes.installerPartner) {
    links.push(...overview(), installationInfo(), installationLinks(), ...business(), service())
  } else if (userType === UserTypes.companyOwner) {
    links.push(...overview(), installationInfo(), installationLinks(), ...business(), service())
  } else if (userType === UserTypes.service) {
    links.push(...overview(), installationInfo(), installationLinks(), serviceAndManagment())
  }

  /*
   * TODO: Answer the question what links are still required?
   */
  const USED_RIGHT_NOW_DUMMY = false
  if (USED_RIGHT_NOW_DUMMY) links.push(...administration, adminLinks)

  return links
}

export default useLinks
